import React from 'react';
import PropTypes from 'prop-types';
import InfoIconWhite from 'core/assets/svg/ic-info-white.svg?react';
import InfoIconDark from 'core/assets/svg/ic-info-dark.svg?react';
import useStyles from './banner.styles';

const Banner = ({ variant, title, subtitle }) => {
  const classes = useStyles();
  const isWarning = variant === 'warning';

  return (
    <div className={isWarning ? classes.warningBanner : classes.banner}>
      {isWarning ? <InfoIconWhite /> : <InfoIconDark />}
      <div className={classes.bannerText}>
        <div className={classes.bannerTitle}>{title}</div>
        {subtitle && <div>{subtitle}</div>}
      </div>
    </div>
  );
};

Banner.propTypes = {
  variant: PropTypes.oneOf(['notification', 'warning']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

export default Banner;
